__webpack_require__.p = "https://gizmeon.mdc.akamaized.net/files/web/staging/str-template/build-v1.0.5/";